/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, model, output } from '@angular/core';
import { FilterMatchMode } from 'primeng/api';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { translationSchema } from '@well/translation';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
@Component({
  selector: 'lib-multiselect-filter',
  standalone: true,
  imports: [MultiSelectModule, FormsModule, TranslateModule, SharedComponentsModule],
  templateUrl: './multiselect-filter.component.html',
  styleUrl: './multiselect-filter.component.scss',
})
export class MultiselectFilterComponent {
  options = model<string[]>([]);
  filterMatchMode = model<FilterMatchMode>(FilterMatchMode.IN);
  value = model<string[]>([]);
  dataCy = model<string>('');

  filtersChange = output<FilterMetadata>();

  search(value: string) {
    const filterMetadata: FilterMetadata = {
      value: value,
      matchMode: this.filterMatchMode().toString(),
    };
    this.filtersChange.emit(filterMetadata);
  }

  protected readonly translationSchema = translationSchema;
}
